define.alias("shared/components/shared/wizards/carousel/step-one", "calendar/components/shared/wizards/carousel/step-one");